import { configureStore } from '@reduxjs/toolkit';
import { bookingReducer } from './booking';
import { usersReducer } from './users';
import { placeReducer } from './place';
import { dateReducer } from './date';

export default configureStore({
  reducer: {
    booking: bookingReducer,
    users: usersReducer,
    place: placeReducer,
    date: dateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
